/* Made in England Research: search, filters and copy buttons. No dependencies. */
(function () {
  var d = document;
  function all(s, c) { return [].slice.call((c || d).querySelectorAll(s)); }
  function el(t, c, x) { var e = d.createElement(t); if (c) e.className = c; if (x != null) e.textContent = x; return e; }

  // Copy buttons: a citation, or the page link when no source is named
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rs-copy]');
    if (!b) return;
    var src = d.getElementById(b.getAttribute('data-rs-copy')), was = b.textContent,
      text = src ? src.textContent.trim() : location.href.split('?')[0];
    if (navigator.clipboard) navigator.clipboard.writeText(text);
    b.textContent = 'Copied';
    setTimeout(function () { b.textContent = was; }, 1500);
  });

  // Research menu: on a narrow screen it scrolls sideways. Fade the right edge while there is more to see,
  // and start with the current page's link in view.
  var rn = d.querySelector('.rs-rn .rs-w');
  if (rn) {
    var here = rn.querySelector('a[aria-current]');
    var edge = function () { rn.parentNode.classList.toggle('rs-rn-more', rn.scrollWidth - rn.clientWidth - rn.scrollLeft > 8); };
    if (here && here.offsetLeft + here.offsetWidth > rn.clientWidth) rn.scrollLeft = here.offsetLeft - 24;
    rn.addEventListener('scroll', edge, { passive: true });
    window.addEventListener('resize', edge);
    edge();
  }

  // Bars behind the percentages in simple tables, drawn from the numbers already in each cell.
  // Only tables with one to three columns of percentages get them. Summary rows of averages are left plain.
  all('.rs-prose[data-rs-bars] table').forEach(function (t) {
    var rows = all('tbody tr', t), cols = {}, n = 0, k;
    rows.forEach(function (r) {
      [].forEach.call(r.cells, function (c, i) { if (/^\d+(\.\d+)?%$/.test(c.textContent.trim())) cols[i] = (cols[i] || 0) + 1; });
    });
    for (k in cols) { if (cols[k] * 2 > rows.length) n++; else delete cols[k]; }
    if (n < 1 || n > 3 || rows.length < 3) return;
    t.classList.add('rs-bt', 'rs-bt-' + n);
    all('tr', t).forEach(function (r) {
      var avg = /^(mean|average)\b/i.test(r.cells[0] ? r.cells[0].textContent.trim() : '');
      [].forEach.call(r.cells, function (c, i) {
        var v = parseFloat(c.textContent);
        if (!(i in cols)) return;
        c.classList.add('rs-bc');
        if (c.tagName == 'TD' && !avg && /%$/.test(c.textContent.trim()) && v >= 0 && v <= 100) c.style.setProperty('--v', v);
      });
    });
  });

  // Wide tables scroll inside their own box on small screens
  all('.rs-prose table').forEach(function (t) {
    var w = el('div', 'rs-tb');
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
    if (w.scrollWidth > w.clientWidth) { w.tabIndex = 0; w.setAttribute('role', 'region'); w.setAttribute('aria-label', 'Table, scrolls sideways'); }
  });

  var form = d.querySelector('[data-rs-search]');
  if (!form) return;

  var q = form.querySelector('input[type=search]'), res = d.getElementById('rs-results'),
    out = res.querySelector('[data-rs-out]'), cnt = res.querySelector('[data-rs-count]'),
    fronts = all('.rs-front'), index = null, asked = false, st = { q: '', topic: '', format: '', label: '' };

  function topics(i) { return (i.getAttribute('data-topics') || '').split('|').filter(Boolean); }
  function isRow(i) { return i.classList.contains('rs-row'); }

  // One of each: the same piece can appear as the lead and again in a list
  var uniq = [], at = {};
  all('[data-rs-item]').forEach(function (i) {
    var k = i.getAttribute('data-url') || i.getAttribute('data-title') || '';
    if (k in at) { if (isRow(i) && !isRow(uniq[at[k]])) uniq[at[k]] = i; return; }
    at[k] = uniq.length;
    uniq.push(i);
  });

  function text(i) {
    if (i._t == null) i._t = [i.textContent, i.getAttribute('data-title'), i.getAttribute('data-summary'), i.getAttribute('data-keys')].join(' ').toLowerCase();
    var u = i.getAttribute('data-url');
    return i._t + (index && u && index[u] ? ' ' + index[u] : '');
  }

  // Every result is shown as the same ruled row, whatever it looks like on the front page
  function row(i) {
    var r;
    if (isRow(i)) { r = i.cloneNode(true); r.hidden = false; r.removeAttribute('data-rs-item'); return r; }
    function a(n) { return i.getAttribute('data-' + n) || ''; }
    var url = a('url'), num = el('p', 'rs-num'), body = el('div', 'rs-row-b'), h = el('h3'), mt = el('p', 'rs-mt'), t, l;
    r = el('article', 'rs-row');
    if (a('stat')) { num.appendChild(el('b', '', a('stat'))); num.appendChild(el('span', '', a('stat-label'))); }
    t = el(url ? 'a' : 'span', '', a('title'));
    if (url) t.href = url;
    h.appendChild(t);
    body.appendChild(h);
    if (a('summary')) body.appendChild(el('p', 'rs-sm', a('summary')));
    mt.appendChild(el('span', '', a('format')));
    if (topics(i)[0]) mt.appendChild(el('span', '', topics(i)[0]));
    if (a('date')) mt.appendChild(el('span', '', a('date')));
    if (a('tag')) mt.appendChild(el('span', 'rs-tag', a('tag')));
    if (url) { l = el('a', '', a('action') || 'Open'); l.href = url; mt.appendChild(l); }
    r.appendChild(num); r.appendChild(body); r.appendChild(mt);
    return r;
  }

  function match(i, s, f) {
    return (!s || text(i).indexOf(s) > -1) && (!st.topic || topics(i).indexOf(st.topic) > -1) && (!f || f.indexOf(i.getAttribute('data-format')) > -1);
  }

  function apply(push) {
    var s = st.q.trim().toLowerCase(), f = st.format ? st.format.split(',') : null, on = !!(s || st.topic || f), hit, what = [], p, u;
    fronts.forEach(function (x) { x.hidden = on; });
    res.hidden = !on;
    if (on) {
      hit = uniq.filter(function (i) { return match(i, s, f); });
      out.textContent = '';
      hit.forEach(function (i) { out.appendChild(row(i)); });
      if (s) what.push('“' + st.q.trim() + '”');
      if (st.topic) what.push(st.topic);
      if (f) what.push(st.label || st.format);
      cnt.textContent = hit.length ? hit.length + (hit.length == 1 ? ' result for ' : ' results for ') + what.join(', ')
        : 'Nothing for ' + what.join(', ') + '. Try a shorter word, or browse by topic.';
    }
    if (push && window.history && history.replaceState) {
      p = new URLSearchParams(location.search);
      ['q', 'topic', 'format'].forEach(function (k) { p.delete(k); });
      if (s) p.set('q', st.q.trim());
      if (st.topic) p.set('topic', st.topic);
      if (st.format) p.set('format', st.format);
      u = p.toString();
      history.replaceState(null, '', location.pathname + (u ? '?' + u : ''));
    }
  }

  // The full text of every piece is fetched once, the first time the search box is used
  function load() {
    var u = form.getAttribute('data-index');
    if (asked || !u || !window.fetch) return;
    asked = true;
    fetch(u).then(function (r) { return r.text(); }).then(function (t) {
      var n = new DOMParser().parseFromString(t, 'text/html').getElementById('rs-index'), m = {};
      JSON.parse(n ? n.textContent : t).forEach(function (x) { m[x.u] = (x.t || '').toLowerCase(); });
      index = m;
      if (st.q) apply();
    }).catch(function () {});
  }

  q.addEventListener('focus', load);
  q.addEventListener('input', function () { st.q = q.value; apply(true); });
  form.addEventListener('submit', function (e) { e.preventDefault(); st.q = q.value; load(); apply(true); });

  // Browse links and "see all" links filter the page in place
  d.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-rs-topic],a[data-rs-format],a[data-rs-clear]');
    if (!a) return;
    e.preventDefault();
    st = { q: '', topic: a.getAttribute('data-rs-topic') || '', format: a.getAttribute('data-rs-format') || '', label: a.getAttribute('data-rs-label') || a.textContent.trim() };
    q.value = '';
    apply(true);
    window.scrollTo(0, 0);
  });

  // Topic chips above the latest findings
  var box = d.querySelector('[data-rs-chips]');
  if (box) {
    var list = all('.rs-row', box.parentNode), lim = +box.getAttribute('data-limit') || 0, names = [], tally = {},
      none = box.parentNode.querySelector('[data-rs-empty]');
    list.forEach(function (r) { topics(r).forEach(function (t) { if (!tally[t]) { tally[t] = 0; names.push(t); } tally[t]++; }); });
    names = names.filter(function (t) { return tally[t] < list.length; }).sort();
    if (names.length > 1) {
      [''].concat(names).forEach(function (t) {
        var b = el('button', 'rs-ch', t || 'All topics');
        b.type = 'button';
        b.setAttribute('data-t', t);
        b.setAttribute('aria-pressed', !t);
        box.appendChild(b);
      });
      box.hidden = false;
      box.addEventListener('click', function (e) {
        var b = e.target.closest('.rs-ch'), t, n = 0;
        if (!b) return;
        t = b.getAttribute('data-t');
        all('.rs-ch', box).forEach(function (c) { c.setAttribute('aria-pressed', c === b); });
        list.forEach(function (r, k) {
          var ok = !t || topics(r).indexOf(t) > -1;
          if (ok) n++;
          r.hidden = !ok || (!t && lim > 0 && k >= lim);
        });
        if (none) none.hidden = n > 0;
      });
    }
  }

  // Counts beside each topic and format; an empty one says so instead of linking nowhere
  all('.rs-br li').forEach(function (li) {
    var a = li.querySelector('a'), n = li.querySelector('i'), t, f, c, s;
    if (!a || !n) return;
    t = a.getAttribute('data-rs-topic');
    f = (a.getAttribute('data-rs-format') || '').split(',');
    c = uniq.filter(function (i) { return t ? topics(i).indexOf(t) > -1 : f.indexOf(i.getAttribute('data-format')) > -1; }).length;
    if (c) { n.textContent = c; return; }
    s = el('span', '', a.textContent);
    li.replaceChild(s, a);
    n.textContent = li.parentNode.getAttribute('data-empty') || '';
  });

  var p = new URLSearchParams(location.search);
  st.q = p.get('q') || '';
  st.topic = p.get('topic') || '';
  st.format = p.get('format') || '';
  if (st.q) { q.value = st.q; load(); }
  if (st.q || st.topic || st.format) apply();
  // A shorter prompt in the search box on a narrow screen
  var full = q.placeholder, short = q.getAttribute('data-short'), mq = window.matchMedia && matchMedia('(max-width:30rem)');
  var prompt = function () { q.placeholder = mq.matches ? short : full; };
  if (mq && short) {
    prompt();
    if (mq.addEventListener) mq.addEventListener('change', prompt); else if (mq.addListener) mq.addListener(prompt);
  }
})();
